module.exports = __webpack_public_path__ + "static/Sal-8234139181ca9e9c0fcf084330b7b30c.png";